module.exports = __webpack_public_path__ + "static/media/UofI.b61617be.png";